import React from "react";
import { Spinner } from "react-bootstrap";
import RIcon from "../reservas/components/ReservasIcons";
import { courtNameFor } from "./birthdayModel";
import { StepDetalles, StepFecha, StepPaquete } from "./BirthdaySteps";
import "../reservas/reservas.css";
import "../reservas/reservas-mobile.css";
import "./cumpleanos.css";

const PROGRESS = { paquete: 34, fecha: 67, detalles: 100 };
const TITLES = { paquete: "Tu cumple", fecha: "Fecha y horario", detalles: "Tus datos" };

/** Mobile wizard: top header with progress bar and a bottom action bar. Renders what `useBirthdayFlow` hands it. */
const BirthdayFlowMobile = ({ flow, club, courts, submitLabel, onBack: handleBack }) => {
  const { step, config, mode, selectedPackage, amounts } = flow;

  return (
    <div className="reservas-root rmob-root bday">
      <div className="rmob-header">
        <button type="button" className="rmob-back" onClick={handleBack} aria-label="Volver">
          <RIcon name="chevL" width={20} height={20} />
        </button>
        <div className="rmob-header-center">
          <span className="rmob-header-title">{TITLES[step]}</span>
          <span className="rmob-header-sub">{club.name}</span>
        </div>
        <div className="rmob-header-spacer" />
      </div>
      <div className="rmob-progress">
        <div className="rmob-progress-bar" style={{ width: `${PROGRESS[step]}%` }} />
      </div>

      <div className="bday-column">
        {step === "paquete" && (
          <StepPaquete packages={flow.packages} selectedId={selectedPackage?._id} onSelect={flow.selectPackage} />
        )}
        {step === "fecha" && (
          <StepFecha
            dateOptions={flow.dateOptions}
            date={flow.date}
            onSelectDate={flow.selectDate}
            availability={flow.availability}
            slotStart={flow.slotStart}
            onSelectStart={flow.selectStart}
            onRetry={flow.reloadAvailability}
            slotNotice={flow.slotNotice}
            courts={courts}
            courtNameOf={courtNameFor}
          />
        )}
        {step === "detalles" && (
          <StepDetalles
            pkg={selectedPackage}
            mode={mode}
            date={flow.date}
            slotStart={flow.slotStart}
            courtName={flow.courtName}
            amounts={amounts}
            depositPercent={config.depositPercent}
            config={config}
            enabled={flow.enabledQuestions}
            form={flow.form}
            onField={flow.setField}
            errors={flow.errors}
            policyAccepted={flow.policyAccepted}
            onPolicy={flow.setPolicyAccepted}
            depositBlocked={flow.depositBlocked}
            submitError={flow.submitError}
          />
        )}
      </div>

      <div className="bday-cta">
        <div className="bday-cta-inner">
          <button type="button" className="r-btn-soft rmob-back-btn" onClick={handleBack}>
            <RIcon name="chevL" width={16} height={16} /> Volver
          </button>
          {step === "detalles" ? (
            <button
              type="button"
              className="r-btn-primary rmob-cta-btn"
              disabled={flow.submitting || flow.depositBlocked}
              onClick={flow.submit}
            >
              {flow.submitting ? <Spinner animation="border" size="sm" /> : submitLabel}
            </button>
          ) : (
            <button type="button" className="r-btn-primary rmob-cta-btn" disabled={!flow.canContinue} onClick={flow.goNext}>
              Continuar <RIcon name="arrowR" width={18} height={18} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BirthdayFlowMobile;
